import ToolboxView from './ToolboxView';

export default ToolboxView;
